import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import ConversationApi from 'dashboard/api/conversations';
import { isConversationNotificationMuted } from 'dashboard/helper/conversationNotificationMute';
import types from 'dashboard/store/mutation-types';

export function useConversationNotificationMute(conversationId) {
  const store = useStore();
  const isUpdating = ref(false);
  const isMuted = computed(() =>
    isConversationNotificationMuted(
      store.getters.getUISettings,
      store.getters.getCurrentAccountId,
      conversationId.value
    )
  );
  const toggleMute = async () => {
    if (isUpdating.value) return;
    isUpdating.value = true;
    try {
      const { data } = await ConversationApi.setNotificationMute(
        conversationId.value,
        !isMuted.value
      );
      store.commit(types.SET_CURRENT_USER_UI_SETTINGS, {
        uiSettings: { muted_conversations: data.muted_conversations },
      });
    } finally {
      isUpdating.value = false;
    }
  };
  return { isMuted, isUpdating, toggleMute };
}
